<form (submit)="$event.preventDefault(); save()">
  <h1 mat-dialog-title>{{ dialogData.simpleCounter.title }}</h1>

  <mat-dialog-content>
    @if (dialogData.simpleCounter.isTrackStreaks) {
      <section class="streak-info">
        <div class="streak-current">
          <div class="label">
            {{ T.F.SIMPLE_COUNTER.D_EDIT.CURRENT_STREAK | translate }}
          </div>
          <div class="value">
            <strong
              >{{ currentStreak() }}
              {{ T.F.SIMPLE_COUNTER.D_EDIT.DAYS | translate }}</strong
            >
          </div>
        </div>

        <div class="streak-goal">
          <div class="label">{{ T.F.SIMPLE_COUNTER.D_EDIT.DAILY_GOAL | translate }}</div>
          <div class="value">
            <strong>
              @if (dialogData.simpleCounter.type === SimpleCounterType.StopWatch) {
                {{ dialogData.simpleCounter.streakMinValue | msToString }}
              } @else {
                {{ dialogData.simpleCounter.streakMinValue }}
              }
            </strong>
          </div>
        </div>
      </section>
    }

    @if (chartData()) {
      <section class="chart-section">
        <div class="chart-wrapper">
          <canvas
            baseChart
            [type]="'line'"
            [data]="chartData()"
            [options]="chartOptions"
            [legend]="false"
            (chartClick)="onChartClick($event)"
          >
          </canvas>
        </div>
      </section>
    }

    <div class="edit-section">
      <div class="date-label">Edit for {{ formatSelectedDate() }}</div>

      @switch (dialogData.simpleCounter.type) {
        @case (SimpleCounterType.StopWatch) {
          <mat-form-field>
            <mat-label>{{ T.F.SIMPLE_COUNTER.D_EDIT.L_COUNTER | translate }}</mat-label>
            <input
              matInput
              inputDuration="optional"
              type="text"
              name="count"
              [ngModel]="selectedValue()"
              (ngModelChange)="updateValue($event)"
            />
            <mat-icon matPrefix>timer</mat-icon>
          </mat-form-field>
        }
        @default {
          <mat-form-field>
            <mat-label>{{ T.F.SIMPLE_COUNTER.D_EDIT.L_COUNTER | translate }}</mat-label>
            <input
              matInput
              type="number"
              name="count"
              [ngModel]="selectedValue()"
              (ngModelChange)="updateValue($event)"
            />
          </mat-form-field>
        }
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      mat-button
      type="button"
      (click)="close()"
    >
      {{ T.G.CANCEL | translate }}
    </button>
    <button
      mat-stroked-button
      color="primary"
      type="submit"
    >
      <mat-icon>save</mat-icon>
      {{ T.G.SAVE | translate }}
    </button>
  </mat-dialog-actions>
</form>
